import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
/**
 * Glass card — the structural primitive of the portal.
 *
 * Picks up the Chaosology signature: translucent white body
 * (`--glass-bg` / `--glass-bg-strong`), glass border, the 1px top-highlight
 * gradient (via `.surface-card::before` in tailwind.css), layered drop
 * shadow, and the 28px (`--r-xl`) rounded corner.
 *
 * Prefer `<article>` or `<section>` when the card carries a heading;
 * `<div>` only when purely presentational (spec §9.1).
 */
export function Card({ as: Tag = 'article', variant = 'default', className, children, ...rest }) {
    return (_jsx(Tag, { className: clsx('surface-card p-[22px]', variant === 'strong' &&
            // Slightly stronger glass — used for modals, detail panels, the
            // auth-layout card, etc.
            'bg-[var(--glass-bg-strong)]', className), ...rest, children: children }));
}
/**
 * Standard card header: Instrument Serif title with optional italic accent
 * (pass <em>word</em> into `title` and it'll render in the royal italic),
 * mono/muted subtitle, and a right-aligned action slot for "View all →"
 * links or inline buttons. Bottom border matches the mockup.
 */
export function CardHeader({ title, subtitle, action, className }) {
    return (_jsxs("div", { className: clsx('flex items-start justify-between gap-4 pb-4 mb-4 border-b border-[var(--line-2)]', className), children: [_jsxs("div", { children: [_jsx("h2", { className: clsx('font-normal leading-[1.15] tracking-[-0.015em] text-[22px] text-[var(--ink-900)]', 
                        // The mockup renders <em> in italic royal for accent words inside
                        // card titles — matches `.card-title em` in the HTML reference.
                        '[&>em]:italic [&>em]:text-[var(--royal-text)] [&>em]:font-[inherit]'), style: { fontFamily: 'var(--f-display)' }, children: title }), subtitle && (_jsx("p", { className: "mt-1 text-[13px] leading-[1.5] text-[var(--ink-500)]", children: subtitle }))] }), action && _jsx("div", { className: "shrink-0", children: action })] }));
}
